import React, { useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import {
  isUserSaved,
  requestLoginIfNeeded,
  saveUserData,
  deleteUserData,
  sessionAuthenticated
} from "../../../keycloak/keycloakFunctions";
import { BeatLoader } from "react-spinners";
import { Col, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import PartyService from "../../../services/PartyService";

const KeycloakInitializing = () => (
  <div className="initializing">
    <Row className="d-flex justify-content-center">
      <Col>
        <h1>
          <dt>{labels.loading}...</dt>
        </h1>
      </Col>
    </Row>
    <Row className="d-flex justify-content-center">
      <Col>
        <BeatLoader size={15} margin={10} color={"#1890ff"} />
      </Col>
    </Row>
  </div>
);

const KeycloakProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const [user, setUser] = useState(undefined);

  const saveUser = userData => {
    saveUserData(userData, keycloak);
    setUser(userData);
  };

  const isAuthenticated = () => {
    const authenticated = sessionAuthenticated(keycloak);

    if (keycloak && !authenticated) {
      deleteUserData();
      requestLoginIfNeeded(keycloak);
    }

    if (keycloak && authenticated && (!user || !isUserSaved())) {
      const partyService = new PartyService(keycloak);
      const onError = error => {
        console.error(error);
        alert(error?.text || error);
      };
      partyService.getCurrentParty(partyData => {
        partyService.getPartyClassificationsByOperation(
          partyData.id,
          operationClassifications => {
            partyData.operationClassifications = operationClassifications;
            saveUser(partyData);
          },
          onError
        );
      }, onError);
    }

    return authenticated;
  };

  return isAuthenticated() && user && isUserSaved() ? (
    children
  ) : (
    <KeycloakInitializing />
  );
};

export default KeycloakProvider;
